var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsappLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_905_965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.686334 15.8086C0.685585 18.4972 1.3934 21.1224 2.73931 23.4363L0.557617 31.3423L8.70955 29.2209C10.9643 30.4391 13.4905 31.0775 16.0577 31.0776H16.0644C24.5392 31.0776 31.4378 24.2332 31.4414 15.8206C31.443 11.7441 29.8449 7.91076 26.9414 5.02679C24.0384 2.14307 20.1775 0.554107 16.0638 0.552246C7.58808 0.552246 0.689959 7.39628 0.686459 15.8086",
    fill: "url(#paint0_linear_905_965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.137622 15.8035C0.136748 18.5889 0.869936 21.308 2.26383 23.7048L0.00390625 31.8942L8.44814 29.6967C10.7748 30.9558 13.3944 31.6196 16.06 31.6206H16.0668C24.8456 31.6206 31.992 24.53 31.9958 15.8162C31.9973 11.5932 30.3417 7.62208 27.3345 4.63479C24.3269 1.64788 20.3279 0.00173643 16.0668 0C7.28656 0 0.141121 7.08961 0.137622 15.8035ZM5.16647 23.292L4.85118 22.7953C3.52576 20.7036 2.82619 18.2865 2.82719 15.8045C2.82994 8.56174 8.76893 2.66915 16.0718 2.66915C19.6084 2.67064 22.9321 4.03895 25.4319 6.52155C27.9317 9.0044 29.3072 12.3049 29.3063 15.8152C29.3031 23.058 23.364 28.9513 16.0668 28.9513H16.0616C13.6856 28.9501 11.3553 28.3168 9.32304 27.12L8.83941 26.8353L3.82844 28.1393L5.16647 23.292Z",
    fill: "url(#paint1_linear_905_965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0854 9.19662C11.7872 8.53888 11.4734 8.52561 11.1898 8.51407C10.9576 8.50415 10.6922 8.5049 10.427 8.5049C10.1616 8.5049 9.73033 8.604 9.3658 8.99904C9.00089 9.39445 7.97266 10.35 7.97266 12.2934C7.97266 14.237 9.39892 16.1152 9.59774 16.379C9.79682 16.6423 12.3512 20.7582 16.3966 22.3415C19.7588 23.6574 20.443 23.3957 21.1727 23.3297C21.9025 23.264 23.5276 22.3744 23.8591 21.452C24.1909 20.5297 24.1909 19.7391 24.0914 19.5739C23.992 19.4093 23.7265 19.3105 23.3285 19.113C22.9304 18.9154 20.9736 17.9598 20.6088 17.8279C20.2439 17.6962 19.9786 17.6305 19.7132 18.026C19.4477 18.4209 18.6856 19.3105 18.4532 19.5739C18.2212 19.838 17.9889 19.8708 17.591 19.6733C17.1927 19.4751 15.9109 19.0584 14.3902 17.7128C13.207 16.6658 12.4082 15.3727 12.176 14.9772C11.9438 14.5823 12.1511 14.3682 12.3507 14.1714C12.5295 13.9944 12.7488 13.7101 12.948 13.4795C13.1465 13.2488 13.2127 13.0842 13.3454 12.8208C13.4783 12.5571 13.4118 12.3264 13.3124 12.1288C13.2127 11.9313 12.4393 9.97764 12.0854 9.19662Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_905_965",
    x1: 1544.75,
    y1: 3079.56,
    x2: 1544.75,
    y2: 0.552246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_905_965",
    x1: 1599.6,
    y1: 3189.42,
    x2: 1599.6,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_905_965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLogo);
export default __webpack_public_path__ + "static/media/whatsappLogo.7bd1af285537a1520f74efbe3e99762a.svg";
export { ForwardRef as ReactComponent };